import type { ReactNode } from 'react';
import { Sidebar } from './Sidebar.js';

interface Props {
  children: ReactNode;
}

/**
 * AppShell V2 — Layout général : sidebar fixe à gauche + zone de contenu.
 * Inclut le bandeau "V2 — PROTOTYPE" pour distinguer visuellement de V1.
 */
export function AppShell({ children }: Props) {
  return (
    <>
      <div className="v2-banner">
        🚧 Cockpit V2 — Prototype refonte · Élève démo : MARTINE VILLARD
      </div>
      <div className="v2-content flex min-h-screen bg-neutral-50">
        <Sidebar />
        <main className="ml-60 flex-1 p-8">{children}</main>
      </div>
    </>
  );
}
